import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import { useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import "../assets/css/ViewJobs.css";
import Navbar from "../components/Navbar";
import { getJobsByJobId, getJobSeeker } from '../helpers/backendHelper';
import { isObjectEmpty } from "../helpers/utility";
import { decryptParam, encryptParam } from '../helpers/UrlEncryptDecrypt';

const JobDetail = () => {

    document.title = "Job Detail";

    const { user } = useSelector((state) => ({
        user: state.Login.user,
    }));

    const secretKey = process.env.REACT_APP_WALKUPP_SECRET_KEY || "walkupp-secret-key";

    let { jobId } = useParams();
    let { isIdFromMyjobs } = useParams();

    jobId = decryptParam(jobId,secretKey);
    // isIdFromMyjobs = decryptParam(isIdFromMyjobs,secretKey);
    console.log("isIdFromMyjobs",isIdFromMyjobs);
    const [myJobsId,setMyJobsId] = useState(isIdFromMyjobs);

    const [jobDetail, setJobDetail] = useState(null);

    const isLoggedIn = localStorage.getItem("authUser");
    const isProfileUpdated = localStorage.getItem("isProfileUpdated");
    const [userData, setUserData] = useState({
        name: "",
        email: "",
        mobileNumber: "",
        employerCity: "",
        employerCountry: "",
        employerArea: "",
        employerPincode: "",
        employerStreet: "",
        isTwoFAEnabled: "",
        isTwoFASetup: "",
        isProfileUpdate: false,
    });

    const navigate = useNavigate();

    const fetchJobDetail = async (jobId) => {
        try{
            const response = await getJobsByJobId(jobId);
            console.log("response jobId",response);
            setJobDetail(response.jobs);
        }
        catch(error){
            console.log("error Job Detail cannot be fetched",error);
        }
    }
    

    useEffect(()=>{
        if(jobId){
            // console.log("jobId from params:", jobId);
            fetchJobDetail(jobId);
            
        }
    },[jobId])

    useEffect(() => {
        const timerId = setTimeout(() => {
            console.log("users",user);
            if(isLoggedIn){
                fetchUserData();
            }
            // if (!isObjectEmpty(user)) {
            //     fetchUserData();
            //     if (isProfileUpdated) {
            //     fetchUserData();
            //     }
            // }
        }, 1000);
        return () => clearTimeout(timerId);
    }, []);
    
    const fetchUserData = async () => {
        try {
            const response = await getJobSeeker();
            if (response && response.statusCode === 200) {
            const data = response.jobseeker;
            console.log("data of jobseeker",data);
            setUserData(data);
            }
        } catch (error) {
            console.error("Error fetching user data:", error);
        }
    };

    const handleApply = (jobId) => {
        if (isLoggedIn === null) {
            Swal.fire({
            title: "You need to signUp or signIn!",
            text: "To apply for this job, you need to signUp or singnIn first.",
            icon: "info",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "SignUp/SignIn",
            cancelButtonText: "Cancel",
            }).then((result) => {
            if (result.isConfirmed) {
                navigate("/auth/signup");
            }
            });
        } else if (userData.isProfileUpdate === false) {
            Swal.fire({
            title: "You need to update your profile!",
            text: "To apply for this job, you need to update your profile first.",
            icon: "info",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Update",
            cancelButtonText: "Cancel",
            }).then((result) => {
            if (result.isConfirmed) {
                navigate("/jobSeeker/profile");
            }
            });
        } else {
            navigate(`/applyjob/${encryptParam(jobId,secretKey)}`);
        }
    }

    return(
        <Container fluid className="job-detail-main">
            <Navbar />

             <div className="job-listing p-1 pt-5 p-sm-5 jobdetail d-flex justify-content-center align-items-center">
                <div>
                    {jobDetail && Array.isArray(jobDetail) && jobDetail.length > 0 && (
                        jobDetail.map((job) => (
                            <h2 className="occupation-title mb-5 mb-sm-0" key={job._id}>{job.jobBasics?.jobTitle}</h2>
                        ))
                    )}
                </div>
            </div>

            <Container >
                <Row>
                    <Col xl={8} className='mt-4 mt-sm-5 mb-2'>
                        {/* <div className='social-media'>
                            <Row>
                                <Col>
                                    {jobDetail && Array.isArray(jobDetail) && jobDetail.length > 0 && (
                                        jobDetail.map((job) => (
                                            <h2 className="job-heading" key={job._id}>{job.jobBasics.jobTitle}</h2>
                                        ))
                                    )}
                                </Col>
                            </Row>
                        </div> */}

                        {jobDetail && Array.isArray(jobDetail) && jobDetail.length > 0 && (
                            jobDetail.map((job) => (
                                <div className='p-2 p-sm-4 div-border'>
                                    <h3 className='mt-2 mb-3'>Job Description</h3>
                                    
                                    <div
                                    // className="jobdescription-scroll"
                                    dangerouslySetInnerHTML={{
                                        __html: job.jobDescription,
                                    }}
                                    />
                                </div>
                            ))
                        )}

                    </Col>

                    <Col xl={4} className='mt-5 d-flex justify-content-center'>
                        <div>
                            { jobDetail && Array.isArray(jobDetail) && jobDetail.length > 0 ? (
                                jobDetail.map((job) => (
                                    <Card className="profile-card text-center sticky-right mb-2" key={job._id}>
                                        <Card.Body>
                                            <div className="avatar-detail">
                                                <span className="initials">{job.companyName[0]}</span>
                                            </div>
                                            <Card.Title><Link className="alpha-link2" to=''>{job.companyName}</Link></Card.Title>
                                            {/* <Button className="visit-website-btn">
                                                Visit website
                                            </Button> */}
                                            <hr className='hr-slash' />
                                            <Row className="text-left">
                                                <Col sm={6} md={4} xl={6} className='p-0 text-start mb-4'>
                                                    <p>Job role</p>
                                                    <span>{job.jobBasics?.jobTitle}</span>
                                                </Col>

                                                <Col sm={6} md={4} xl={6} className='p-0 text-start mb-4'>
                                                    <p className='job-head'>Salary</p>
                                                    <span className='job-value'>{job.salary?.range?.minimum} - {job.salary?.range?.maximum} / year</span>
                                                </Col>

                                                <Col sm={6} md={4} xl={6} className='p-0 text-start mb-4'>
                                                    <p>Currency</p>
                                                    <span>INR</span>
                                                </Col>

                                                <Col sm={6} md={4} xl={6} className='p-0 text-start mb-4'>
                                                    <p>Location</p>
                                                    <span>{job.jobBasics?.jobLocation ? job.jobBasics.jobLocation.city : "Location not Specified"}</span>
                                                </Col>

                                                <Col sm={6} md={4} xl={6} className='p-0 text-start mb-4'>
                                                    <p>Job type</p>
                                                    <span>{job.jobDetails.jobType}</span>
                                                </Col>

                                                <Col sm={6} md={4} xl={6} className='p-0 text-start mb-4'>
                                                    <p>Work mode</p>
                                                    <span>{job.jobBasics?.jobType}</span>
                                                </Col>

                                                <Col sm={6} md={4} xl={6} className='p-0 text-start mb-4'>
                                                    <p>Openings</p>
                                                    <span>{job.jobDetails.numberOfPositions}</span>
                                                </Col>

                                                <Col sm={6} md={4} xl={6} className='p-0 text-start mb-4'>
                                                    <p>Work schedule</p>
                                                    <span>{job.jobDetails.schedule}</span>
                                                </Col>

                                                <Col sm={6} md={4} xl={6} className='p-0 text-start mb-4'>
                                                    <p>Experience</p>
                                                    <span>{job.jobDetails.experiance}{job.jobDetails.experiance === "Fresher" ? "" : " years"}</span>
                                                </Col>

                                                <Col sm={6} md={4} xl={6} className='p-0 text-start mb-4'>
                                                    <p>Education level</p>
                                                    <span>{job.jobDetails.educationLevel}</span>
                                                </Col>

                                                <Col sm={6} md={4} xl={6} className='p-0 text-start mb-4'>
                                                    <p>Planned date</p>
                                                    <span>{job.jobDetails?.date ? job.jobDetails.date : "Date not specified"}</span>
                                                </Col>

                                                <Col sm={6} md={4} xl={6} className='p-0 text-start mb-4'>
                                                    <p>Recruitment timeline</p>
                                                    <span>{job.jobDetails.recruitmentTimeline}</span>
                                                </Col>
                                            </Row>
                                            
                                            <Row>
                                                <Col xs={12}>
                                                    {
                                                        isIdFromMyjobs === "true" ? null :
                                                            (
                                                                <Button className="detail-login-btn ms-0" onClick={() => handleApply(job._id)}>
                                                                    Apply
                                                                </Button>
                                                            )
                                                        
                                                    }
                                                </Col>
                                            </Row>

                                        </Card.Body>
                                    </Card>
                                ))
                            ) : (
                                <p>No job details available</p>
                            )}
                        </div>

                    </Col>
                </Row>
            </Container>
        </Container>
    )
}

export default JobDetail;